'use strict';

/**
 * Rechner for Rentenlücken-Rechner and Riester-Rechner
 * Copy the functions JS from old BVI
 */

 // import Calcore
var Calcore;
((Calcore = Calcore || {}).bruttoNettoRechner = {
  SOLI: 0.055,
  VERHEIRATET: !0,
  RENTENVERSICHERUNGS_ANTEIL_PROZENT: 0.0935,
  ANTEIL_KRANKENVERSICHERUNG: 0.12,
  KK_DECKEL_MINDESTANSATZ_VERHEIRATET: 3e3,
  KK_DECKEL_MINDESTANSATZ_NICHT_VERHEIRATET: 1900,
  ARBEITNEHMER_ANTEIL_BRUTTO_LOHN: 0.09475,
  WERBUNGS_KOSTEN_PAUSCHALE: 1e3,
  SONDER_AUSGABEN_PAUSCHALE: 36,
  KINDER_FREIBETRAG: 2730,
  ERZIEHUNGS_FREIBETRAG: 1464,
  BBG_GKV: 52200,
  ZUGANGS_WERT_RENTEN_VERSICHERUNG: 0.84,
  NETTO_RENTE_WERBUNGS_KOSTEN_PAUSCHALE: 102,
  NETTO_RENTE_SONDERAUSGABEN_PAUSCHALE: 36,
  NETTO_RENTE_VORSORGE_AUFWENDUNGEN: 7.3,
  NETTO_RENTE_SOZIALABGABEN: 9.85,
  VEREINFACHT_SOZIALABGABEN: 0.2,
  berechneNettoLohn: function (e, r, t, n) {
    var E = Calcore.bruttoNettoRechner.berechneSteuern(e, r, t, n, 0),
      o = Calcore.bruttoNettoRechner.berechneSozialabgaben(e),
      a = e - E - o;
    return (
      Calcore.log.debug(
        "[7] Berechne Netto Lohn: \n\nBruttolohn: " +
        Calcore.helper.round2(e) +
        "\nSteuern: " +
        Calcore.helper.round2(E) +
        "\nSozialabgaben: " +
        Calcore.helper.round2(o) +
        "\n -> NettoLohn (bruttolohn - Steuern - Sozailabgaben): " +
        Calcore.helper.round2(a) +
        "\n"
      ),
        a
    );
  },
  berechneSteuern: function (e, r, t, n, E) {
    var o = Calcore.bruttoNettoRechner.berechneteBesteuerbarerAnteil(r, E, e, t, n),
      a = Calcore.bruttoNettoRechner.berechneEinkommenssteuer(o, r),
      l = Calcore.bruttoNettoRechner.berechneSoli(a, r),
      i = a + l;
    return (
      Calcore.log.debug(
        "[5] Berechne Steuern: \n\nBesteuerbarer Anteil: " +
        Calcore.helper.round2(o) +
        "\nEinkommenssteuer: " +
        Calcore.helper.round2(a) +
        "\nSoli: " +
        Calcore.helper.round2(l) +
        "\n -> Steuern (eink. Steuer + Soli): " +
        Calcore.helper.round2(i)
      ),
        i
    );
  },
  berechneteBesteuerbarerAnteil: function (e, r, t, n, E) {
    var o = this.WERBUNGS_KOSTEN_PAUSCHALE,
      a = this.SONDER_AUSGABEN_PAUSCHALE;
    e == this.VERHEIRATET && ((o *= 2), (a *= 2));
    var l = (this.KINDER_FREIBETRAG + this.ERZIEHUNGS_FREIBETRAG) * r;
    return e == this.VERHEIRATET && (l *= 2), t - o - a - Calcore.bruttoNettoRechner.berechneVorsorgePauschale(t, e, n, E) - l;
  },
  berechneEinkommenssteuer: function (e, r) {
    var t = -1;
    r == this.VERHEIRATET && (e /= 2);
    var n = 9744;
    if (e < n) t = 0;
    else if (n + 1 <= e && e <= 14753) {
      var E = (Math.floor(e) - n) / 1e4;
      t = (995.21 * E + 1400) * E;
    } else if (14754 <= e && e <= 57918) {
      var o = (Math.floor(e) - 14753) / 1e4;
      t = (208.85 * o + 2397) * o + 950.96;
    } else if (57919 <= e && e <= 274612) {
      t = 0.42 * Math.floor(e) - 9136.63;
    } else {
      if (!(274613 <= e)) throw "Wert nicht unterstÃ¼tzt: " + e;
      t = 0.45 * Math.floor(e) - 17374.9;
    }
    return (t = Math.floor(t)), r == this.VERHEIRATET && (t *= 2), t;
  },
  berechneSoli: function (e, r) {
    var t = 16956;
    if ((r === this.VERHEIRATET && (t *= 2), t < e)) {
      var n = (5.5 * e) / 100,
        E = (11.9 * (e - t)) / 100;
      return E < n && (n = E), n;
    }
    return 0;
  },
  berechneBesteuerungsanteil: function (e) {
    var r = -1;
    return (
      e <= 2005
        ? (r = 50)
        : 2006 == e
        ? (r = 52)
        : 2007 == e
          ? (r = 54)
          : 2008 == e
            ? (r = 56)
            : 2009 == e
              ? (r = 58)
              : 2010 == e
                ? (r = 60)
                : 2011 == e
                  ? (r = 62)
                  : 2012 == e
                    ? (r = 64)
                    : 2013 == e
                      ? (r = 66)
                      : 2014 == e
                        ? (r = 68)
                        : 2015 == e
                          ? (r = 70)
                          : 2016 == e
                            ? (r = 72)
                            : 2017 == e
                              ? (r = 74)
                              : 2018 == e
                                ? (r = 76)
                                : 2019 == e
                                  ? (r = 78)
                                  : 2020 <= e && e <= 2040
                                    ? (r = 80 + e - 2020)
                                    : 2040 < e && (r = 100),
        r
    );
  },
  berechneVorsorgePauschale: function (e, r, t, n) {
    var E = Calcore.helper.deckel(e, Calcore.helper.getBeitragsBemessungsgrenzeFuerJahr(t, n)),
      o = this.RENTENVERSICHERUNGS_ANTEIL_PROZENT * E * Calcore.bruttoNettoRechner.ermittleZugangswertRentenversicherung(t),
      a = Calcore.helper.deckel(E, this.BBG_GKV),
      l = a * this.ANTEIL_KRANKENVERSICHERUNG,
      i = this.KK_DECKEL_MINDESTANSATZ_NICHT_VERHEIRATET;
    r == this.VERHEIRATET && (i = this.KK_DECKEL_MINDESTANSATZ_VERHEIRATET);
    var R = Calcore.helper.deckel(l, i),
      s = a * this.ARBEITNEHMER_ANTEIL_BRUTTO_LOHN,
      h = s;
    return s < R && (h = R), o + h;
  },
  ermittleZugangswertRentenversicherung: function (e) {
    return this.ZUGANGS_WERT_RENTEN_VERSICHERUNG;
  },
  berechneNettoRente: function (e, r, t) {
    var n = 12 * e,
      E = Calcore.bruttoNettoRechner.berechneBesteuerungsanteil(r),
      o = Calcore.helper.getProzent(n, E),
      a = this.NETTO_RENTE_WERBUNGS_KOSTEN_PAUSCHALE,
      l = this.NETTO_RENTE_SONDERAUSGABEN_PAUSCHALE;
    t == this.VERHEIRATET && ((a *= 2), (l *= 2));
    var i = o - a - l - Calcore.helper.getProzent(n, this.NETTO_RENTE_VORSORGE_AUFWENDUNGEN),
      R = Calcore.bruttoNettoRechner.berechneEinkommenssteuer(i, t),
      s = Calcore.bruttoNettoRechner.berechneSoli(R, t),
      h = Calcore.helper.getProzent(n, this.NETTO_RENTE_SOZIALABGABEN),
      N = (n - R - s - h) / 12;
    return (
      Calcore.log.info(
        "[9]: Berechne Netto Rente: BruttoRente: " +
        Calcore.helper.round2(e) +
        " \nBruttorente im Jahr: " +
        n +
        " \nRenteneintrittsjahr: " +
        r +
        " \nSplitting: " +
        t +
        " \nBestuerungsanteil: " +
        Calcore.helper.round2(E) +
        " \nBesteuerbarer Rentenanteil (Jahr): " +
        Calcore.helper.round2(o) +
        " \nEinkommenssteuer:" +
        Calcore.helper.round2(R) +
        " \nSoli:" +
        Calcore.helper.round2(s) +
        " \nSozialabgaben:" +
        Calcore.helper.round2(h) +
        " \nNetto Rente: " +
        Calcore.helper.round2(N)
      ),
        N
    );
  },
  berechneSozialabgaben: function (e) {
    var r = e * this.VEREINFACHT_SOZIALABGABEN,
      t = "[6] Berechne Sozialabgaben:\n\n";
    return (
      (t += "Bruttolohn: " + Calcore.helper.round2(e) + "\n"),
        (t += "Sozialabgaben-Prozent: " + Calcore.helper.round2(this.VEREINFACHT_SOZIALABGABEN) + "\n"),
        (t += "-> Sozialabgaben: " + Calcore.helper.round2(r) + "\n"),
        Calcore.log.info(t),
        r
    );
  },
}),
  ((Calcore = Calcore || {}).helper = {
    UNTERGRENZE_JAHRGANG_ZUGANGSFAKTOR: 1946,
    OBERGRENZE_JAHRGANG_ZUGANGSFAKTOR: 1964,
    ZUGANGSFAKTOR_63: [92.8, 92.5, 92.2, 91.9, 91.6, 91.3, 91, 90.7, 90.4, 90.1, 89.8, 89.5, 89.2, 88.6, 88, 87.4, 86.8, 86.2, 85.6],
    ZUGANGSFAKTOR_64: [96.4, 96.1, 95.8, 95.5, 95.2, 94.9, 94.6, 94.3, 94, 93.7, 93.4, 93.1, 92.8, 92.2, 91.6, 91, 90.4, 89.8, 89.2],
    ZUGANGSFAKTOR_65: [100, 99.7, 99.4, 99.1, 98.8, 98.5, 98.2, 97.9, 97.6, 97.3, 97, 96.7, 96.4, 95.8, 95.2, 94.6, 94, 93.4, 92.8],
    ZUGANGSFAKTOR_66: [106, 105.5, 105, 104.5, 104, 103.5, 103, 102.5, 102, 101.5, 101, 100.5, 100, 99.4, 98.8, 98.2, 97.6, 97, 96.4],
    ZUGANGSFAKTOR_67: [112, 111.5, 111, 110.5, 110, 109.5, 109, 108.5, 108, 107.5, 107, 106.5, 106, 105, 104, 103, 102, 101, 100],
    ZUGANGSFAKTOR_ZUWACHS_UNTER_67: 0.003,
    START_JAHR_BEMESSUNGS_GRENZE: 1957,
    BEITRAGSBEMESSUNGSGRENZEN_STEIGERUNG_ZUKUNFT: 0.022,
    BEITRAGS_BEMESSUNGS_GRENZE_WEST: [
      4602,
      4602,
      4908,
      5215,
      5522,
      5829,
      6136,
      6749,
      7363,
      7976,
      8590,
      9817,
      10430,
      11044,
      11657,
      12885,
      14112,
      15339,
      17179,
      19020,
      20861,
      22701,
      24542,
      25769,
      26996,
      28837,
      30678,
      31905,
      33132,
      34359,
      34972,
      36813,
      37427,
      38654,
      39881,
      41721,
      44176,
      46630,
      47857,
      49084,
      50311,
      51538,
      52152,
      52765,
      53379,
      54e3,
      61200,
      61800,
      62400,
      63e3,
      63e3,
      63600,
      64800,
      66e3,
      66e3,
      67200,
      69600,
      71400,
      72600,
      74400,
      76200,
      78e3,
      80400,
      82800,
      85200,
    ],
    BEITRAGS_BEMESSUNGS_GRENZE_WEST_ERRECHNET: [],
    BEITRAGS_BEMESSUNGS_GRENZE_OST: [
      4602,
      4602,
      4908,
      5215,
      5522,
      5829,
      6136,
      6749,
      7363,
      7976,
      8590,
      9817,
      10430,
      11044,
      11657,
      12885,
      14112,
      15339,
      17179,
      19020,
      20861,
      22701,
      24542,
      25769,
      26996,
      28837,
      30678,
      31905,
      33132,
      34359,
      34972,
      36813,
      37427,
      16566,
      19632,
      29450,
      32518,
      36199,
      39267,
      41721,
      43562,
      44789,
      45e3,
      51e3,
      52200,
      52800,
      52800,
      54600,
      54e3,
      54600,
      55800,
      57600,
      57600,
      58800,
      6e4,
      62400,
      64800,
      68400,
      70247,
      72143,
      74091,
      69600,
      73800,
      77400,
      80400,
    ],
    BEITRAGS_BEMESSUNGS_GRENZE_OST_ERRECHNET: [],
    DURCHSCHNITTS_EINKOMMEN_PRO_JAHR: [
      909,
      909,
      937,
      1135,
      1451,
      1616,
      1830,
      1969,
      2076,
      2165,
      2325,
      2477,
      2578,
      2725,
      2864,
      3119,
      3437,
      3747,
      3975,
      4329,
      4719,
      5058,
      5225,
      5543,
      6053,
      6822,
      7634,
      8352,
      9354,
      10421,
      11150,
      11931,
      12754,
      13417,
      14155,
      15075,
      15799,
      16463,
      17022,
      17533,
      18041,
      18727,
      19289,
      19887,
      20484,
      21447,
      22712,
      23939,
      24633,
      25126,
      25905,
      26423,
      26660,
      27060,
      27358,
      27741,
      28231,
      28626,
      28938,
      29060,
      29202,
      29494,
      29951,
      30625,
      30506,
      31144,
      32100,
      33002,
      33659,
      34514,
      35363,
      36187,
      37077,
      38212,
      39301,
      40551,
      41541,
    ],
    ANFANGSJAHR_DURCHSCHNITTSEINKOMMEN: 1945,
    ECHTER_RENTENWERT_OST: 33.23,
    ECHTER_RENTENWERT_WEST: 34.19,
    ECHTER_RENTENWERT_JAHR: 2021,
    MAXIMAL_JAHR_ZUKUNFT_RENTENWERTE: 2100,
    WEST: !0,
    OST: !1,
    getZugangsfaktor: function (e, r, t) {
      e < this.UNTERGRENZE_JAHRGANG_ZUGANGSFAKTOR && (e = this.UNTERGRENZE_JAHRGANG_ZUGANGSFAKTOR), e > this.OBERGRENZE_JAHRGANG_ZUGANGSFAKTOR && (e = this.OBERGRENZE_JAHRGANG_ZUGANGSFAKTOR);
      var n = 0;
      switch (t) {
        case 63:
          n = this.zugangsfaktorAusTabelle(e, this.ZUGANGSFAKTOR_63);
          break;
        case 64:
          n = this.zugangsfaktorAusTabelle(e, this.ZUGANGSFAKTOR_64);
          break;
        case 65:
          n = this.zugangsfaktorAusTabelle(e, this.ZUGANGSFAKTOR_65);
          break;
        case 66:
          n = this.zugangsfaktorAusTabelle(e, this.ZUGANGSFAKTOR_66);
          break;
        case 67:
          n = this.zugangsfaktorAusTabelle(e, this.ZUGANGSFAKTOR_67);
          break;
        default:
          Calcore.log.error("kein plausibles renteneintrittsdatum!!:" + t);
      }
      return t < 67 && (n += r * this.ZUGANGSFAKTOR_ZUWACHS_UNTER_67), n;
    },
    zugangsfaktorAusTabelle: function (e, r) {
      return r[e - this.UNTERGRENZE_JAHRGANG_ZUGANGSFAKTOR] / 100;
    },
    getBeitragsBemessungsgrenzeFuerJahr: function (e, r) {
      this.initBeitragsbemessungsgrenzen();
      var t = r == this.OST ? this.BEITRAGS_BEMESSUNGS_GRENZE_OST_ERRECHNET : this.BEITRAGS_BEMESSUNGS_GRENZE_WEST_ERRECHNET,
        n = this.START_JAHR_BEMESSUNGS_GRENZE;
      return e - n >= t.length ? 5e6 : e - n < 0 ? this.BEITRAGS_BEMESSUNGS_GRENZE_WEST[0] : t[e - n - 1];
    },
    getDurchschnittseikommendesJahres: function (e, r) {
      for (var t = this.DURCHSCHNITTS_EINKOMMEN_PRO_JAHR.slice(), n = t.length, E = n; E < n + 60; E++) t[E] = this.getProzent(t[E - 1], 100 + r);
      return t[e - this.ANFANGSJAHR_DURCHSCHNITTSEINKOMMEN];
    },
    rentenwerte_west: null,
    rentenwerte_ost: null,
    getRentenwertDesJahres: function (e, r, t) {
      if (null == this.rentenwerte_west) {
        var rentenwerte_west = []; var rentenwerte_ost = []; (rentenwerte_west[this.ECHTER_RENTENWERT_JAHR] = this.ECHTER_RENTENWERT_WEST), (rentenwerte_ost[this.ECHTER_RENTENWERT_JAHR] = this.ECHTER_RENTENWERT_OST);
        for (var n = this.ECHTER_RENTENWERT_JAHR + 1; n < this.MAXIMAL_JAHR_ZUKUNFT_RENTENWERTE; n++)
          (rentenwerte_ost[n] = rentenwerte_ost[n - 1] + this.getProzent(rentenwerte_ost[n - 1], t)), (rentenwerte_west[n] = rentenwerte_west[n - 1] + this.getProzent(rentenwerte_west[n - 1], t));
      }
      return r == this.OST ? rentenwerte_ost[e] : rentenwerte_west[e];
    },
    getJaehrlicheSteigerung: function (e, r, t, n) {
      return r <= e ? n : t;
    },
    arthmetischesMittel: function (e, r) {
      return (Math.abs(e) + Math.abs(r)) / 2;
    },
    getProzent: function (e, r) {
      return (e * r) / 100;
    },
    deckelNach0: function (e) {
      var r = e;
      return e < 0 && (r = 0), r;
    },
    round: function (e, r) {
      if (0 == r) return Math.round(e);
      if (r < 1 || 14 < r) return !1;
      var t = Math.pow(10, r),
        n = (Math.round(e * t) / t).toString();
      return -1 == n.indexOf(".") && (n += "."), (n += t.toString().substring(1)).substring(0, n.indexOf(".") + r + 1);
    },
    round2: function (e) {
      return this.round(e, 2);
    },
    round0: function (e) {
      return this.round(e, 0);
    },
    deckel: function (e, r) {
      var t = e;
      return r < e && (t = r), t;
    },
    zinseszins: function (e, r, t) {
      return e * Math.pow(t / 100 + 1, r);
    },
    berechneKaufkraft: function (e, r, t) {
      return e * Math.pow(1 - (1 - 1 / (1 + t / 100)), r);
    },
    mapToText: function (e) {
      for (var r = "", t = e.getMinYear(); t <= e.getMaxYaer(); t++) {
        var n = "" + this.round2(e.getYearValue(t));
        r += t + ": " + (n = n.split(".").join(",")) + "\n";
      }
      return r;
    },
    initBeitragsbemessungsgrenzen: function () {
      if (0 == this.BEITRAGS_BEMESSUNGS_GRENZE_WEST_ERRECHNET.length) {
        for (var e = 0; e < this.BEITRAGS_BEMESSUNGS_GRENZE_WEST.length; e++) this.BEITRAGS_BEMESSUNGS_GRENZE_WEST_ERRECHNET[e] = this.BEITRAGS_BEMESSUNGS_GRENZE_WEST[e];
        for (e = this.BEITRAGS_BEMESSUNGS_GRENZE_WEST.length; e < this.BEITRAGS_BEMESSUNGS_GRENZE_WEST.length + 60; e++)
          this.BEITRAGS_BEMESSUNGS_GRENZE_WEST_ERRECHNET[e] = this.BEITRAGS_BEMESSUNGS_GRENZE_WEST_ERRECHNET[e - 1] + this.BEITRAGS_BEMESSUNGS_GRENZE_WEST_ERRECHNET[e - 1] * this.BEITRAGSBEMESSUNGSGRENZEN_STEIGERUNG_ZUKUNFT;
        for (e = 0; e < this.BEITRAGS_BEMESSUNGS_GRENZE_OST.length; e++) this.BEITRAGS_BEMESSUNGS_GRENZE_OST_ERRECHNET[e] = this.BEITRAGS_BEMESSUNGS_GRENZE_OST[e];
        for (e = this.BEITRAGS_BEMESSUNGS_GRENZE_OST.length; e < this.BEITRAGS_BEMESSUNGS_GRENZE_OST.length + 60; e++)
          this.BEITRAGS_BEMESSUNGS_GRENZE_OST_ERRECHNET[e] = this.BEITRAGS_BEMESSUNGS_GRENZE_OST_ERRECHNET[e - 1] + this.BEITRAGS_BEMESSUNGS_GRENZE_OST_ERRECHNET[e - 1] * this.BEITRAGSBEMESSUNGSGRENZEN_STEIGERUNG_ZUKUNFT;
        console.log(this.BEITRAGS_BEMESSUNGS_GRENZE_OST_ERRECHNET);
      }
    },
  }),
  ((Calcore = Calcore || {}).log = {
    messages: "",
    debug: function (e) {
      Calcore.log._writeToConsole("" + e);
    },
    info: function (e) {
      Calcore.log._writeToConsole("" + e);
    },
    error: function (e) {
      Calcore.log._writeToConsole("" + e);
    },
    getMessageStack: function () {
      return this.messages;
    },
    _writeToConsole: function (e) {
      console.log(e);
      var r = e.replace(/\n/g, "<br>");
      this.messages += r + "<hr>";
    },
  }),
  ((Calcore = Calcore || {}).rentenErgebnis = function () {
    (this.letzterNettoLohn = -1),
      (this.ersteNettoRente = -1),
      (this.versorgungsluecke = -1),
      (this.abweichungvonNettoLohn = -1),
      (this.versorgungsZiel = -1),
      (this.rentenluecke = -1),
      (this.optimaleRenteAb = -1),
      (this.einkommensReihe = -1),
      (this.punkte = -1),
      (this.rente = -1),
      (this.nettoRente = -1),
      (this.vermindertesLetztesEinkommen = -1),
      (this.luecke = -1),
      (this.zugangsFaktor = -1);
  }),
  (Calcore.renten = {
    RENTEN_LUECKE_PROZENT: 80,
    RENTENWERT_STEIERUNG_IN_ZUKUNFT: 2.1,
    MINIMALES_AKTUELLES_JAHR: 2018,
    MAXIMALES_AKTUELLES_JAHR: 2023,
    berechneRente: function (e, r, t, n, E, o, a, l, i, R, s, h) {
      var N = Calcore.renten.RENTEN_LUECKE_PROZENT,
        u = Calcore.renten.RENTENWERT_STEIERUNG_IN_ZUKUNFT;
      "" == a ? ((a = -1), (t = 0)) : (a = parseInt(a));
      try {
        Calcore.renten.meldeProblem(e, R - o + 1, R - 20, "Jahrgang "),
          Calcore.renten.meldeProblem(r, 1, 12, "Geburtsmonat "),
          Calcore.renten.meldeProblem(n, 0, 2e6, "Gehalt "),
        -1 == a && Calcore.renten.meldeProblem(E, e + 14, R - 1, "Berufseinstieg "),
          Calcore.renten.meldeProblem(o, 63, 67, "Renteneintrittsalter "),
        -1 != a && (Calcore.renten.meldeProblem(a, R - 5, R, "Renteninformation von Jahr "), Calcore.renten.meldeProblem(t, 0, 150, "Bisherige Entgeldpunkte ")),
          Calcore.renten.meldeProblem(l, 0, 15, "Lohnsteigerung in der Zukunft "),
          Calcore.renten.meldeProblem(i, 0, 15, "Inflation "),
          Calcore.renten.meldeProblem(R, Calcore.renten.MINIMALES_AKTUELLES_JAHR, Calcore.renten.MAXIMALES_AKTUELLES_JAHR, "Aktuelles Jahr "),
          Calcore.renten.meldeProblemBoolean(s, "Bundesland "),
          Calcore.renten.meldeProblemBoolean(h, "Splitting  ");
      } catch (e) {
        throw e;
      }
      Calcore.log.info("[1] Eingabewerte auf Plausibilitaet geprueft"), (Calcore.rentenpunkteRechner.LOHNSTEIGERUNG_ZUKUNFT = l);
      var c = Calcore.rentenpunkteRechner.berechneEinkommensreihe(e, t, n, E, o, R, a);
      Calcore.log.debug("[2]: Einkommensreihe Gesamt (ungedeckelt): \n\n" + Calcore.helper.mapToText(c));
      var T = Calcore.rentenpunkteRechner.berechneRentenpunkte(c, a, E, e, t, o, s),
        _ = Calcore.rentenpunkteRechner.berechneRente(T, e, r, o, s, u),
        S = c.getYearValue(c.getMaxYaer()),
        A = Calcore.bruttoNettoRechner.berechneNettoLohn(S, h, R, s),
        g = e + o - R,
        G = Calcore.helper.berechneKaufkraft(A, g, i);
      Calcore.log.debug("[8]: Realer Nettolohn: \n\nNettolohn: " + A + "\nInflationssatz: " + i + "\nJahre: " + g + "\nNetto Lohn real: " + G);
      var C = Calcore.bruttoNettoRechner.berechneNettoRente(_, o + e, h),
        f = Calcore.helper.berechneKaufkraft(C, g, i);
      Calcore.log.debug("Reale netto Rente: \n\nNettorente: " + C + "\nInflationssatz: " + i + "\nJahre: " + g + "\nNetto Rente real: " + f);
      var U = Calcore.helper.getProzent(A / 12, N),
        b = Calcore.helper.deckelNach0(U - C),
        B = Calcore.helper.getProzent(G / 12, N);
      Calcore.log.debug("[10]: Versorgungsziel: \n\nrealer Nettolohn: " + G + "\nRentenlÃ¼cke in Prozent: " + N + "\n");
      var I = Calcore.helper.deckelNach0(B - f);
      Calcore.log.debug("[11]: Reale RentenlÃ¼cke: \n\nVerorgungsziel: " + U + "\nReale Nettorente: " + f + "\n");
      var m = 100 * Calcore.helper.getZugangsfaktor(e, r, o),
        Z = new Calcore.rentenErgebnis();
      return (
        (Z.letzterNettoLohn = G / 12),
          (Z.ersteNettoRente = f),
          (Z.versorgungsluecke = I),
          (Z.abweichungvonNettoLohn = (100 * f) / Z.letzterNettoLohn),
          (Z.versorgungsZiel = (Z.letzterNettoLohn * N) / 100),
          (Z.rentenluecke = (100 * I) / Z.versorgungsZiel),
          (Z.einkommensReihe = c),
          (Z.punkte = T),
          (Z.rente = _),
          (Z.nettoRente = C),
          (Z.vermindertesLetztesEinkommen = U),
          (Z.luecke = b),
          (Z.zugangsFaktor = m),
          Z
      );
    },
    meldeProblem: function (e, r, t, n) {
      if (isNaN(e)) throw n + " ist keine Zahl!";
      if (e < r || t < e) throw n + " muss zwischen " + r + " und " + t + " liegen.";
    },
    meldeProblemBoolean: function (e, r, t, n) {
      return !isNaN(e);
    },
  }),
  ((Calcore = Calcore || {}).rentenpunkteRechner = {
    WEIBLICH: !1,
    MAENNLICH: !0,
    OKAY_VALUE: "okay",
    LOHNSTEIGERUNG_VERGANGENHEIT: 2.75,
    LOHNSTEIGERUNG_ZUKUNFT: 2.3,
    FIXIERTE_LOHNSTEIGERUNG_ZUKUNFT: 1.9,
    berechneDifferenzBeiZins: function (e, r, t) {
      return this.berechneBarwertEinzahlungen(r, e) - this.berechneBarwertAuszahlungen(t, e);
    },
    version: function () {
      console.log("20210329");
    },
    berechneEinkommensreihe: function (e, r, t, n, E, o, a) {
      for (var l = new Calcore.YearMap(), i = e + E, R = t, s = o; s < i; s++) {
        var h = R;
        l.putYear(s, h);
        var N = Calcore.helper.getJaehrlicheSteigerung(s, o, Calcore.rentenpunkteRechner.LOHNSTEIGERUNG_VERGANGENHEIT, Calcore.rentenpunkteRechner.LOHNSTEIGERUNG_ZUKUNFT);
        R = Calcore.helper.getProzent(R, N + 100);
      }
      var u = a + 1;
      -1 == a && (u = n), (R = t);
      for (s = o - 1; u <= s; s--) {
        h = R /= 1 + (N = Calcore.helper.getJaehrlicheSteigerung(s, o, Calcore.rentenpunkteRechner.LOHNSTEIGERUNG_VERGANGENHEIT, Calcore.rentenpunkteRechner.LOHNSTEIGERUNG_ZUKUNFT)) / 100;
        l.putYear(s, h);
      }
      return l;
    },
    berechneRentenpunkte: function (e, r, t, n, E, o, a) {
      var l = E,
        i = n + o;
      -1 == r && ((l = 0), (r = t - 1));
      for (var R = "[3]: Berechne Rentenpunkte:\n\n", s = r + 1; s < i; s++) {
        var h = Calcore.helper.getDurchschnittseikommendesJahres(s, Calcore.rentenpunkteRechner.FIXIERTE_LOHNSTEIGERUNG_ZUKUNFT),
          N = e.getYearValue(s),
          u = N,
          c = Calcore.helper.getBeitragsBemessungsgrenzeFuerJahr(s, a);
        c < N && (R += "Bemessungsgrenze im jahr " + s + " ueberschritten!(" + (u = c) + "/" + N + ")");
        var T = u / h;
        (l += T = Calcore.helper.deckel(T, 2)),
          (R += "Punkte fuer Jahr: " + s + " :" + Calcore.helper.round2(T) + " (Einkommen: " + Calcore.helper.round2(u) + " Durchnitt.: " + Calcore.helper.round2(h) + ") Beitragsbemessungsgrenze: " + c + "\n");
      }
      return Calcore.log.debug(R), l;
    },
    berechneRente: function (e, r, t, n, E, o) {
      var a = Calcore.helper.getZugangsfaktor(r, t, n),
        l = Calcore.helper.getRentenwertDesJahres(r + n, E, o),
        i = e * a * l,
        R = "[4] Berechne Rente: \n";
      return (R += "Punkte: " + e + "\n"), (R += "Zugangsfaktor: " + a + "\n"), (R += "Rentenwert des Jahres: " + l + "\n"), (R += "Rente: " + i + "\n"), Calcore.log.debug(R), i;
    },
  }),
  ((Calcore = Calcore || {}).riesterErgebnis = function () {
    (this.anlageBetragVolleZulage = -1),
      (this.maxZulage = -1),
      (this.optimalerSparanteil = -1),
      (this.abweichungVonOptimal = -1),
      (this.anteiligeZulage = -1),
      (this.anlageBetrag = -1),
      (this.maximalerAnlagebetrag = -1),
      (this.gesamtSteuernOhneRiester = -1),
      (this.gesamtSteuernMitRiester = -1),
      (this.differenz = -1),
      (this.differenzAbzglZulagen = -1),
      (this.foerderquote = -1);
  }),
  (Calcore.riester = {
    PARTNER_MITTELBAR_ZULAGENBERECHTIGT: 1,
    PARTNER_UNMITTELBAR_ZULAGENBERECHTIGT: 2,
    PARTNER_NICHT_ZULAGENBERECHTIGT: 3,
    PROZENT_ANLAGEBETRAG_VOLLE_ZULAGE: 4,
    MAXIMALER_ANLAGEBETRAG: 2100,
    RIESTER_FOERDERUNG: 175,
    FOERDERUNG_KINDER_VOR_2008: 185,
    FOERDERUNG_KINDER_NACH_2008: 300,
    SOCKEL_BETRAG_MINDEST_SPARLEISTUNG: 60,
    berechneRiester: function (e, r, t, n, E, o, a, l, i) {
      try {
        Calcore.riester.meldeProblem(e, 4800, 2e6, "Gehalt "),
        1 == a && Calcore.riester.meldeProblem(r, 0, 2e6, "Gehalt Partner"),
          Calcore.riester.meldeProblem(t, 0, 15, "Anzahl der Kinder vor 2008 "),
          Calcore.riester.meldeProblem(n, 0, 6, "Anzahl der Kinder nach 2008 "),
          Calcore.riester.meldeProblem(E, 60, e, "Eigene jÃ¤hrliche Sparleistung ");
      } catch (e) {
        throw e;
      }
      Calcore.log.info("[1] Eingabewerte auf Plausibilitaet geprueft");
      var R = e;
      1 == a && (R = e + r);
      var s = Calcore.helper.getProzent(e, this.PROZENT_ANLAGEBETRAG_VOLLE_ZULAGE),
        h = this.MAXIMALER_ANLAGEBETRAG;
      (s = Calcore.helper.deckel(s, h)), Calcore.log.info("[2] Anlagebetrag fuer die volle Zulage: " + s);
      var N = this.RIESTER_FOERDERUNG,
        u = N + this.FOERDERUNG_KINDER_VOR_2008 * t + this.FOERDERUNG_KINDER_NACH_2008 * n,
        c = u;
      1 == a && o == Calcore.riester.PARTNER_MITTELBAR_ZULAGENBERECHTIGT && (c = u + N), Calcore.log.info("[3] Volle Zulage: " + c);
      var T = s - c,
        _ = this.SOCKEL_BETRAG_MINDEST_SPARLEISTUNG;
      (T = T < _ ? _ : T), Calcore.log.info("[4] Sparanteil fuer volle Zulage: " + T);
      var S = E / T;
      (S = 1 < S ? 1 : S), Calcore.log.info("[5] Aweichung vom Optimum: " + S);
      var A = S * u;
      Calcore.log.info("[6] Anteilige Zulage: " + A);
      var g = A + E;
      Calcore.log.info("[7]  Anlagebetrag: " + g);
      var G = Calcore.helper.deckel(g, h);
      Calcore.log.info("[8] Gedeckelter Anlagebetrag: " + G);
      var C = Calcore.bruttoNettoRechner.berechneSteuern(R, a, l, i, n);
      Calcore.log.info("[9]  gesamt Steuern ohne Riester: " + C);
      var f = Calcore.bruttoNettoRechner.berechneSteuern(R - G, a, l, i, n);
      Calcore.log.info("[10]  gesamt steuern mit Riester: " + f);
      var U = C - f;
      Calcore.log.info("[11]  Steuerdifferenz: " + U);
      var b = U - A;
      b < 0 && (b = 0), Calcore.log.info("[12]  Steuervoreil: " + b);
      var B = ((b + A) / g) * 100;
      Calcore.log.info("[13]  Foerderquote: " + B);
      var I = new Calcore.riesterErgebnis();
      return (
        (I.anlageBetragVolleZulage = s),
          (I.maxZulage = c),
          (I.optimalerSparanteil = T),
          (I.abweichungVonOptimal = S),
          (I.anteiligeZulage = A),
          (I.anlageBetrag = g),
          (I.maximalerAnlagebetrag = h),
          (I.gesamtSteuernOhneRiester = C),
          (I.gesamtSteuernMitRiester = f),
          (I.differenz = U),
          (I.differenzAbzglZulagen = b),
          (I.foerderquote = B),
          I
      );
    },
    meldeProblem: function (e, r, t, n) {
      if (isNaN(e)) throw n + " ist keine Zahl!";
      if (e < r || t < e) throw n + " muss zwischen " + r + " und " + t + " liegen.";
    },
  }),
  ((Calcore = Calcore || {}).YearMap = function () {
    (this.maxYear = 0),
      (this.minYear = 3e3),
      (this.offset = 1),
      (this.putYear = function (e, r) {
        (this[e] = r), e > this.maxYear && (this.maxYear = e), e < this.minYear && (this.minYear = e);
      }),
      (this.getYearValue = function (e) {
        return this[e];
      }),
      (this.getMaxYaer = function () {
        return this.maxYear;
      }),
      (this.getMinYear = function () {
        return this.minYear;
      }),
      (this.getIndexOfSmallestValue = function () {
        for (var e = 5e7, r = -1, t = this.getMinYear(); t <= this.getMaxYaer(); t += this.offset) Math.abs(this[t]) < e && ((r = t), (e = Math.abs(this[t])));
        return r;
      }),
      (this.getSumme = function () {
        for (var e = 0, r = this.getMinYear(); r <= this.getMaxYaer(); r += this.offset) e += this[r];
        return e;
      }),
      (this.getTeilSumme = function (e, r) {
        for (var t = 0, n = e; n <= r; n += this.offset) t += this[n];
        return t;
      });
  });





export default class RentenlueckenrechnerForm {



    // init
    init() {
      this.language = 0;
      if(document.querySelector('.language')) {
        this.language = document.querySelector('.language').getAttribute("data-language");
      }
        let self = this;

        if (!document.querySelector('.form__rechner')) {
            return false;
        }
        if (document.getElementById('rentenlueckenrechner')) {
            self.rentenlueckenrechner();
        }
        if (document.getElementById('riesterrecher')) {
            self.riesterrecher();
        }
        if (document.getElementById('rechner1')) {
            self.rechner1('rechner1');
        }
        if (document.getElementById('rechner2')) {
            self.rechner2('rechner2');
        }

    }

    // checkt and update form Einmalanlage-Rechner
    rechner2() {
        let self = this;

        self.calcRechner2('#rechner2');
        // TODO: check the event moved.zf.slider not fired here
        $('#rechner2 .input__sliderhandle').on('mousemove', function () {
            $('.input__number').each(function (index, element) {
                $(element).text($(element).val().replace('.', ','));
            });
            self.calcRechner2('#rechner2');
        });
    }

    // check and update Sparplan-Rechner
    rechner1() {
        let self = this;

        self.calcRechner1('#rechner1');
        // TODO: check the event moved.zf.slider not fired here
        $('#rechner1 .input__sliderhandle').on('mousemove', function () {
            $('.input__number').each(function (index, element) {
              if(self.language < 1) {
                $(element).text($(element).val().replace('.', ','));
              } else {
                $(element).text($(element).val());
              }
            });
            self.calcRechner1('#rechner1');
        });
    }

    // check and update form  Riester-Rechner
    riesterrecher() {
        let self = this;

        $('#family_status').change(function () {
            var married = ($('#family_status').val() == "married" ? true : false);
            if (!married) {
                $('#partner_contract').val("no");
                $('#partner_contract_container').fadeOut();
                $('#income_partner_container').fadeOut();
            } else {
                $('#partner_contract').val("yes");
                $('#partner_contract_container').fadeIn();
                $('#income_partner_container').fadeIn();
            }
        });

        $('#submit-button').on('click', function (e) {
            e.preventDefault();
            self.doComputeRiesterrecher();
        });

        // output first call
        self.doTestRiesterrecher();
        self.doComputeRiesterrecher();

    }

    // check and update form Rentenlücken-Rechner
    rentenlueckenrechner() {
        let self = this;

        $('#computationChoice, #computationSort').change(function () {
            let value = $(this).val();
            if (value == "salary") {
                $('#computationPointsContainer').hide();
                $('#computationSalaryContainer').show();
                $('#gained_points_info_year').val("");
            } else {
                $('#computationPointsContainer').show();
                $('#computationSalaryContainer').hide();
            }
        });

        $('#submit-button').on('click', function (e) {
            e.preventDefault();
            self.doComputeRentenlueckenrechner();
        });

        // output first call
        self.doTestRentenlueckenrechner();
        self.doComputeRentenlueckenrechner();

    }

    // calculator for Rentenlücken-Rechner
    doComputeRentenlueckenrechner() {
        let self = this;
        let jahrgang = self.num($('#age-year').val());
        let geburtsmonat = self.num($('#age-month').val());
        let bisherigeEinzahlungen = self.num($('#gained_points').val());
        let gehalt = self.num($('#income').val());

        if ($('#job_start').val() < (jahrgang + 14)) {
            $('#job_start').val(jahrgang + 14);
        }
        let berufseinstieg = self.num($('#job_start').val());

        let beginn_rente = self.num($('#retirement_entry_year').val());
        let renten_info_von = ($('#gained_points_info_year').val() == null ? '' : $('#gained_points_info_year').val());        // wird nicht als Zahl interpretiert, da auch leer sein darf.
        // let lohnsteigerung_vergangenheit = parseFloat($('#salary_gain_past').val());    // wird ignoriert, da interne konstante
        let lohnsteigerung_zukunft = parseFloat(self.kommaToDot($('#salary_gain_future').val()));
        // let rentenlueckeProzent = self.num($('#pension_gap').val());                // wird ignoriert, da interne konstante
        // let bundesland = ($('#state').val() == "new"?Calcore.rentenpunkteRechner.OST:Calcore.rentenpunkteRechner.WEST);
        let bundesland = ($('#state').val() == "new" ? Calcore.helper.OST : Calcore.helper.WEST);
        let splitting = ($('#family_status').val() == "married" ? true : false);

        let theDate = new Date()
        let aktuellesJahr = theDate.getFullYear();

        //console.log(jahrgang + ', ' + geburtsmonat + ', ' + bisherigeEinzahlungen + ', ' + gehalt + ', ' + berufseinstieg + ', ' + beginn_rente + ', ' + renten_info_von + ', ' + lohnsteigerung_zukunft + ', ' + bundesland + ', ' + splitting + ', ' + aktuellesJahr);

        try {
            let inflation = 2;  // BVI wuenscht festen Wert der Inflation von 2 %
            let rueckgabe = Calcore.renten.berechneRente(jahrgang, geburtsmonat, bisherigeEinzahlungen, gehalt, berufseinstieg, beginn_rente,
                renten_info_von, lohnsteigerung_zukunft, inflation, aktuellesJahr, bundesland, splitting);
            //console.log(rueckgabe);
            let debugMessages = Calcore.log.getMessageStack();
            $('#debug_output_message').html(debugMessages);

            this.abweichungvonNettoLohn = -1;  // entspricht xx% des letzten Netto-Lohns
            this.versorgungsZiel = -1;  // entspricht 80% des letzten Netto-Lohns
            this.rentenluecke = -1;     // entspricht xx % des Versorgungsziels

            $('#result_netto').html(self.kDot(Calcore.helper.round0(rueckgabe.letzterNettoLohn)) + " EUR");
            $('#result_netto_rente').html(self.kDot(Calcore.helper.round0(rueckgabe.ersteNettoRente)) + " EUR " +
                " (entspricht " + Calcore.helper.round0(rueckgabe.abweichungvonNettoLohn) + "% des letzten Netto-Lohns)");

            $('#versorgungsziel').html("Versorgungsziel: <strong>" + self.kDot(Calcore.helper.round0(rueckgabe.versorgungsZiel)) + " EUR</strong> " +
                " (entspricht <strong>" + 80 + "%</strong> des letzten Netto-Lohns)");

            $('#versorgungsziel').html("Versorgungsziel: <strong>" + self.kDot(Calcore.helper.round0(rueckgabe.versorgungsZiel)) + " EUR</strong> " +
                " (entspricht <strong>" + 80 + "%</strong> des letzten Netto-Lohns)");

            $('#rentenluecke').html("Rentenlücke: <strong>" + Calcore.helper.round0(rueckgabe.versorgungsluecke) + " EUR</strong> " +
                " (entspricht <strong>" + Calcore.helper.round0(rueckgabe.rentenluecke) + "%</strong> des Versorgungsziels)");


            $('#luecke').html(self.kDot(Calcore.helper.round0(rueckgabe.versorgungsluecke)) + " €");

            $('#rente').html(self.kDot(Calcore.helper.round0(rueckgabe.ersteNettoRente)) + " €");


            $('#outRenteJahr').html($('#retirement_entry_year').val());
            $('#outRenteMonat').html($('#age-month').val());
            $('#outRente').html(self.kDot(Calcore.helper.round0(rueckgabe.ersteNettoRente)));
            //            $('#outRenteProzent').html( Calcore.helper.round0(rueckgabe.rentenluecke) );
            $('#outRenteProzent').html(self.kDot(Math.round(Calcore.helper.round0(rueckgabe.ersteNettoRente) / (Calcore.helper.round0(rueckgabe.letzterNettoLohn) / 100))));
            $('#outLohn').html(self.kDot(Calcore.helper.round0(rueckgabe.letzterNettoLohn)));
            $('#outRenteSoll').html(self.kDot(Calcore.helper.round0(rueckgabe.versorgungsZiel)));
            $('#outLuecke').html(Calcore.helper.round0(rueckgabe.versorgungsluecke));


            if (rueckgabe.zugangsFaktor < 100) {
                $('#zugangsFaktor').html("<br/>Beim Renteneintrittsalter " + beginn_rente + " erhalten Sie nur " + rueckgabe.zugangsFaktor +
                    "% der vollen Rente. Probieren Sie doch einmal ein späteres Renteneintrittsalter aus.");
            }
            $('#rentenrechner_result').show();

            // Grafik Output
            let _pRenter = rueckgabe.ersteNettoRente / (rueckgabe.letzterNettoLohn / 100);
            if (_pRenter > 99) _pRenter = 99;
            $("#rentenrechner_result .progress-meter").css("height", _pRenter + "%");
            $("#rentenrechner_result .barRed").css("height", 99 - _pRenter + "%");


        } catch (ex) {
            console.log(ex + "\n\nBerechnung abgebrochen.");
        }


        return false;
    }

    // calculator for  Riester-Rechner
    doComputeRiesterrecher() {
        let self = this;
        // Eingaben:
        let gehalt = parseInt($('#income').val());
        let gehalt_partner = parseInt($('#income_partner').val());
        let anzahlKinderVor2008 = parseInt($('#number_children_before_2008').val());
        let anzahlKinderNach2008 = parseInt($('#number_children_after_2008').val());
        let eigenanteil = parseFloat($('#rate').val());
        let zulagenberechtigt = -1;

        if ($('#partner_contract').val() == "ja_mittelbar") {
            zulagenberechtigt = Calcore.riester.PARTNER_MITTELBAR_ZULAGENBERECHTIGT;
        } else if ($('#partner_contract').val() == "ja_unmittelbar") {
            zulagenberechtigt = Calcore.riester.PARTNER_UNMITTELBAR_ZULAGENBERECHTIGT;
        } else if ($('#partner_contract').val() == "nein") {
            zulagenberechtigt = Calcore.riester.PARTNER_NICHT_ZULAGENBERECHTIGT;
        }

        let bundesland = ($('#state').val() == "new" ? Calcore.rentenpunkteRechner.OST : Calcore.rentenpunkteRechner.WEST);


        let splitting = ($('#family_status').val() == "married" ? true : false);

        let theDate = new Date();
        let diesesJahr = theDate.getFullYear();

        try {
            let rueckgabe = Calcore.riester.berechneRiester(gehalt, gehalt_partner, anzahlKinderVor2008, anzahlKinderNach2008,
                eigenanteil, zulagenberechtigt, splitting, diesesJahr, bundesland);

            let result = "";
            //            result = "Anlagebetrag f&uuml;r die volle Zulage: " + kDot(rueckgabe.anlageBetragVolleZulage) + " &euro;<br>";
            //            result = result + "Volle Zulage: " + kDot(rueckgabe.maxZulage) + " &euro;<br>";
            //            result = result + "Sparanteil für volle Zulage (Optimum): " + kDot(Calcore.helper.round0(rueckgabe.optimalerSparanteil)) + " &euro;<br>";
            //            result = result + "Abweichung vom Optimum: " + dotToKomma(Calcore.helper.round(rueckgabe.abweichungVonOptimal,2)) + "<br>";
            //            result = result + "Anteilige Zulage: " + kDot(Calcore.helper.round0(rueckgabe.anteiligeZulage)) + " &euro;<br>";
            //            result = result + "Tatsächlicher Anlagebetrag: " + kDot(Calcore.helper.round0(rueckgabe.anlageBetrag)) + " &euro;<br>";
            //            result = result + "<hr><br>";
            //
            //            result = result + "Steuern ohne Riester: " + kDot(Calcore.helper.round0(rueckgabe.gesamtSteuernOhneRiester)) + " &euro;<br>";
            //            result = result + "Steuern mit Riester: " + kDot(Calcore.helper.round0(rueckgabe.gesamtSteuernMitRiester)) + " &euro;<br>";
            //            result = result + "Steuerdifferenz: " + kDot(Calcore.helper.round0(rueckgabe.differenz)) + " &euro;<br>";
            //            result = result + "Steuervorteil: " + kDot(Calcore.helper.round0(rueckgabe.differenzAbzglZulagen)) + " &euro;<br>";
            //            result = result + "Förderquote: " + Calcore.helper.round0(rueckgabe.foerderquote) + " %<br>";

            let altOut = rueckgabe.maxZulage;
            if ($('#partner_contract').val() == "ja_mittelbar") altOut = rueckgabe.maxZulage - 175;


            if (!splitting) { // family_status?
                if (rueckgabe.maxZulage > Calcore.helper.round0(rueckgabe.anteiligeZulage)) {
                    result += text.riester.result01 +" <strong>" + self.kDot(Calcore.helper.round0(rueckgabe.anteiligeZulage)) + "&nbsp;"+text.global.euros+"</strong>.<br/>";
                    result += "<br />"+text.riester.result02+" <strong>" + self.kDot((splitting) ? altOut : rueckgabe.maxZulage) + "&nbsp;"+text.global.euros+"</strong> "+text.riester.result03+" <strong>" + self.kDot(rueckgabe.optimalerSparanteil) + "&nbsp;"+text.global.euros+"</strong> "+text.riester.result04+"<br/>";

                } else {
                    result += text.riester.result05+" <strong>" + self.kDot((splitting) ? altOut : rueckgabe.maxZulage) + "&nbsp;Euro</strong>.<br/>";
                }

            } else {
                if (altOut > Calcore.helper.round0(rueckgabe.anteiligeZulage)) {
                    result += text.riester.result06+" <strong>" + self.kDot(Calcore.helper.round0(rueckgabe.anteiligeZulage)) + "&nbsp;Euro</strong>.<br/>";
                    result += "<br />"+text.riester.result07+" <strong>" + self.kDot((splitting) ? altOut : rueckgabe.maxZulage) + "&nbsp;"+text.global.euros+"</strong> "+text.riester.result08+" <strong>" + self.kDot(rueckgabe.optimalerSparanteil) + "&nbsp;"+text.global.euros+"</strong> "+text.riester.result09+"<br/>";

                } else {
                    result += text.riester.result10+" <strong>" + self.kDot((splitting) ? altOut : rueckgabe.maxZulage) + "&nbsp;Euro</strong>.<br/>";
                }
            }
            result += "<br/>"+text.riester.result11+" <strong>" + self.kDot(parseFloat($('#rate').val())) + "&nbsp;"+text.global.euros+"</strong> "+text.riester.result12+" <strong>" + self.kDot(Calcore.helper.round0(rueckgabe.anteiligeZulage)) + "&nbsp;"+text.global.euros+"</strong> "+text.riester.result13+" <strong>" + self.kDot(Calcore.helper.round0(rueckgabe.differenzAbzglZulagen)) + " "+text.global.euros+"</strong>.<br/>";


            if (Calcore.helper.round0(rueckgabe.differenzAbzglZulagen) == 0) {
                result += "<br/>"+text.riester.result14+"<br/>";
            }

            //            result = result + "<br>Um die maximale steuerliche Förderung zu erhalten, müssen<br/>Sie <strong>" +
            //                    kDot((rueckgabe.maximalerAnlagebetrag - rueckgabe.maxZulage)) + "  EURO</strong> einzahlen";

            if (splitting && zulagenberechtigt == Calcore.riester.PARTNER_MITTELBAR_ZULAGENBERECHTIGT) {
                result = result + "<br>"+text.riester.result15;
            }

            // Ausgabe
            $("#anteiligeZulage").html(self.kDot(Calcore.helper.round0(rueckgabe.anteiligeZulage)));

            $("#volleZulage").html(self.kDot(rueckgabe.maxZulage));
            $("#betragVolleZulage").html(self.kDot(rueckgabe.anlageBetragVolleZulage));
            $("#eigeneSparleistung").html(self.kDot(parseFloat($('#rate').val())));
            $("#foerderQuote").html(Calcore.helper.round0(rueckgabe.foerderquote));
            $("#foerderquoteOut").html(Calcore.helper.round0(rueckgabe.foerderquote) + " %");
            $("#steuervorteil").html(self.kDot(Calcore.helper.round0(rueckgabe.differenzAbzglZulagen)));
            $("#optimalerSparanteil").html(self.kDot(rueckgabe.optimalerSparanteil));

            $('.infoText .out').html(result);
            $('#rentenrechner_result').show();
            let debugMessages = Calcore.log.getMessageStack();
            $('#debug_output_message').html(debugMessages);


            // Grafik Output
            let _pQuote = Calcore.helper.round0(rueckgabe.foerderquote);
            $("#rentenrechner_result .progress-meter").css("height", _pQuote + "%");
            //$("#rentenrechner_result .barGreen").css("height",99-_pQuote+"%");


        } catch (ex) {
            console.log(ex + "\nBerechnung abgebrochen.");
        }

        return false;
    }

    // calculator for Sparplan-Rechner
    calcRechner1(_path) {
        let self = this;
        let _in = $('#sliderOutputDeposit').val();
        let _ausgabeP = $('#sliderOutputLoad').val();
        let _dauer = $('#sliderOutputYear').val();
        let _pa = $('#sliderOutputPerformance').val();
        //var anlagebetrag = (_in/100)*(100-_ausgabeP);
        let anlagebetrag = _in / (1 + _ausgabeP / 100);

        let zws = _in * 12 * _dauer;
        let zws2 = anlagebetrag * 12 * _dauer;

        //let div = zws-zws2;
        let erg = anlagebetrag * ((12 / ((_pa / 100 + 1) - 1)) + (13 / 2)) * (Math.pow((_pa / 100 + 1), _dauer) - 1);

        if (_pa == 0) erg = zws2;
        let erg2 = erg; //_in*( (12/((_pa/100+1)-1))+(13/2) ) * ( Math.pow((_pa/100+1),_dauer) -1); // fix wegen ausgabeaufschlag
        erg = Math.round(erg);


        //let anzErg = Math.round(erg);
        let anzErg = erg;
        let anzEinzahlungMinAufschlag = Math.round(zws2);

        let anzEinzahlung = Math.round(zws);
        let anzZuwachs = Math.round((anzErg - anzEinzahlungMinAufschlag));

        //Dieser console.log verursacht einen Fehler im IE
        //console.log(anzZuwachs);

        let pZws = anzEinzahlung / (Math.round(erg2) / 100);
        //            let pZuwachs = anzZuwachs/(anzErg/100);
        //            let pAufschlag = div/(anzErg/100);

        if (anzZuwachs < 0) {
            $(_path).find(".barGreen").addClass("barRed");
        } else {
            $(_path).find(".barGreen").removeClass("barRed");
        }

        // output
        $(_path + " .einzahlung").html(self.kDot(anzEinzahlungMinAufschlag) + " €");
        $(_path + " .zuwachs").html(self.kDot(anzZuwachs) + " €");
        $(_path + " #result_netto").html(self.kDot(anzErg) + " €");

        let tmpP = (this.cap(pZws) - .6);
        $(_path + " .progress-meter").css("height", tmpP + "%");
        //            $(_path+" .barGray").css("width",(this.cap(pAufschlag) -.6)+"%");
        //            $(_path+" .barGreen").css("width",(this.cap(pZuwachs) -.6)+"%");
        //$(_path + " .barGreen").css("height", 99 - tmpP + "%");

    }

    // calculator for Einmalanlage-Rechner
    calcRechner2(_path) {
        let self = this;
        let _in =  $('#disp1').val(); // Anzulegender Betrag
        let _ausgabeP = $('#disp2').val(); // Ausgabeaufschlag
        let _dauer = $('#disp3').val(); // Anlagedauer
        let _pa = $('#disp4').val(); //Wertentwicklung

        //let RenditeFaktor = (_pa/100.0)+1;
        //let erg = _in * Math.pow(RenditeFaktor, _dauer);
        //let erg2 = erg; // fix wegen ausgabeaufschlag
        //erg = erg * (1-(_ausgabeP/100.0));

        let RenditeFaktor = (_pa/100.0)+1;
        //let _inMinusAusgabe = _in * (1-(_ausgabeP/100.0));
        let _inMinusAusgabe = _in / (1+(_ausgabeP/100.0));

        let erg = _inMinusAusgabe * Math.pow(RenditeFaktor, _dauer);
        let erg2 = erg; // fix wegen ausgabeaufschlag
        //erg = erg * (1-(_ausgabeP/100.0));

        //let zws = _in;
        let zws2 = _in/ (1+(_ausgabeP/100.0));

        //let div = zws-zws2;

        let anzErg = Math.round(erg);
        let anzZws = Math.round(zws2);
        let anzZuwachs = Math.round( (anzErg-_inMinusAusgabe));
        let pZws = _in/(Math.round(erg2)/100);
        //let pZuwachs = anzZuwachs/(anzErg/100);
        //let pAufschlag = div/(anzErg/100);

        if(anzZuwachs<0) {
            $(_path).find(".barGreen").addClass("barRed");
        } else {
            $(_path).find(".barGreen").removeClass("barRed");
        }

        // output
        $(_path+" .einzahlung").html(self.kDot(anzZws)+" €");
        $(_path+" .zuwachs").html(self.kDot(anzZuwachs)+" €");
        $(_path+" #erg").html(self.kDot(anzErg)+" €");

        let tmpP = (this.cap(pZws) -.6);
        $(_path+" .progress-meter").css("height",tmpP+"%");
        //$(_path+" .barGray").css("width",(this.cap(pAufschlag) -.6)+"%");
        //$(_path+" .barGreen").css("height",99-tmpP+"%");

    }

    num(val) {
        return parseInt(val.replace(/\D/g, ''));
    }

    // init inputs form Rentenlücken-Rechner
    doTestRentenlueckenrechner() {
        $('#age-year').val(1970);
        $('#age-month').val(10);
        $('#gained_points').val(0);
        $('#gained_points_info_year').val(2012);
        $('#income').val(30000);
        $('#job_start').val(1990);
        $('#inflation').val(2);
        $('#salary_gain_future').val(2);
        return false;
    }

    // init inputs form Riester-Rechner
    doTestRiesterrecher() {
        $('#income').val(30000);
        $('#number_children_before_2008').val(0);
        $('#number_children_after_2008').val(0);
        $('#rate').val(1000);
        return false;
    }

    dotToKomma(val) {
        val += "";
        let t = val.split(".");

        return (t[1] == undefined) ? t[0] : t[0] + "," + t[1];
    }

    kommaToDot(val) {

        val += "";
        let t = val.split(",");

        return (t[1] == undefined) ? t[0] : t[0] + "." + t[1];
    }

    cap(val) {
        val = (val < 0.7) ? 0.7 : val;
        val = (val > 99.3) ? 99.3 : val;
        return val;
    }

    kDot(val) {

        let self = this;
        if (val > 0) {
            val = self.dotToKomma(val);
            var t = val.split(",");
            if (t[0] > 0) {
                var out = "";
                var c = 0;

                t[0] += "";
                var tmp = t[0].split("");

                for (let i = 0; i < tmp.length; i++) {

                    c = (tmp.length - i) % 3;
                    if (c == 0 && i > 0) out += ".";
                    out = out + "" + tmp[i];

                }
            } else {
                out = t[0] + "," + t[1];
            }

          if(self.language > 0) {
            out = out.replace('.', ',');
          }

            if (t[1] == undefined) {
                return out;
            } else {
                return out + "," + t[1];
            }
        } else {
            return "0";
        }

    }

}
